<template>
    <b-modal
        id="module-show-unregister-modal"
        v-model="modal"
        :title="module && `Uitschrijven voor ${module.title}`"
        :ok-title="$t('common.close')"
        ok-only
        @hide="onHide"
        modal-class="apprentice-default-modal module-show-unregister-modal">
        <div
            class="unregister"
            v-if="module">
            <div class="info muted-text">{{ $t('modules.overview_of_registered_dates') }}</div>
            <h6 class="title">{{ $t('modules.overview_of_registered_dates') }}</h6>
            <div
                class="module-dates"
                v-if="module.module_dates && module.module_dates.length > 0">
                <div
                    class="module-date"
                    v-for="date in module.module_dates"
                    v-if="date.userHasRegistration($authUser.id)">
                    <div class="icon">
                        <i class="fas fa-clock"></i>
                    </div>
                    <div class="register-date">
                        <span
                            >{{ date.start_date | date_named_month_short }} -
                            {{ date.end_date | date_named_month_short }}</span
                        >
                    </div>
                    <b-button
                        class="btn-sign-out btn-module-sign-out remove-icon-margin"
                        v-b-tooltip.hover
                        variant="danger-icon"
                        :title="$t('modules.unsubscribe')"
                        @click="removeDate(date)">
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

const modulesOrds = ords.use('module');

export default {
    name: 'design-2021-module-show-unregister-modal-component',
    props: {},
    data() {
        return {
            modal: false,
            module: [],
            subscription: null,
        };
    },
    methods: {
        removeDate(checked, date) {
            this.alert
                .confirm(
                    this.$t('modules.unsubscribe_module'),
                    this.$t('modules.are_you_sure_you_want_to_unsubscribe_from_this_time_block'),
                    this.$t('modules.yes_sign_out'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    let moduleUser = this.module.findModuleUserByUserId(this.$authUser.id);
                    this.alert.saving();
                    this.axios.delete(this.routes.deleteModuleUser(moduleUser.id)).then(
                        (response) => {
                            moduleUser.remove();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        show(moduleId) {
            this.subscription = modulesOrds
                .with('module_dates', (dateCallback) => {
                    dateCallback.with('module_users');
                    dateCallback.with('module_period', (modulePeriodsCallback) => {
                        modulePeriodsCallback.with('period');
                    });
                })
                .find(moduleId)
                .subscribe((module) => {
                    this.module = module;
                });
            this.modal = true;
        },

        onHide() {
            this.subscription.unsubscribe();
        },
    },
};
</script>

<style scoped lang="scss">
.info {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.date {
    display: flex;
    align-items: center;
}

.title {
    margin-bottom: map-get($grid-gutter-spacing, 'eight');
    font-size: 1rem;
}

.module-dates {
    .module-date {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding-top: map-get($grid-gutter-spacing, 'ten');

        .icon {
            align-self: center;
            padding: map-get($grid-gutter-spacing, 'ten');
            margin-right: map-get($grid-gutter-spacing, 'eight');
            border-radius: $border-radius-content;
            color: $primary;
            background-color: $secondary-background-color;
            font-size: 1.3125rem;
            line-height: 1;
        }

        .register-date {
            margin-left: map-get($grid-gutter-spacing, 'twenty-one');
            font-weight: $font-weight-medium;
        }

        .btn-module-sign-out {
            margin-left: auto;
        }

        &:not(:last-child) {
            padding-bottom: map-get($grid-gutter-spacing, 'ten');
            border-bottom: 3px dotted $border-color;
        }
    }
}
</style>
